<section class="aux-page aux-about">
    <div class="aux-head">
        <p class="aux-eyebrow">About</p>
        <h1>Built On Fair, Family-Style Service</h1>
        <p>
            We are a family-owned team focused on practical deals, honest
            guidance, and long-term customer relationships.
        </p>
    </div>

    <div class="aux-grid two">
        <article class="aux-panel">
            <h2>What Makes Us Different</h2>
            <ul class="aux-list">
                <li>Fair pricing and straightforward financing guidance.</li>
                <li>
                    Independent access to a broad range of domestic and import
                    vehicles.
                </li>
                <li>
                    Support built around your goals, not a one-size-fits-all
                    pitch.
                </li>
            </ul>
        </article>

        <article class="aux-panel">
            <h2>Our Story</h2>
            <p>
                We launched in 2009, building on more than 20 years of vehicle
                sales experience. We work like a mortgage broker for vehicle
                buyers: understand budget, evaluate trade-in or down payment,
                and match the best lending options.
            </p>
            <p>
                After pre-approval, we source the right vehicle at the right
                price, with nationwide delivery and trade-in pickup.
            </p>
        </article>
    </div>
</section>
